import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { VehicleInfo } from "../../../queries/useGetVehicleInfo";
import { WheelPartItem } from "../../../queries/useSearchWheelsByVehicle";
import { Pagination } from "../../../ui/Pagination/Pagination";
import { NoData } from "../../NoData/NoData";
import { useVisualizerProductId } from "../../Visualizer/useVisualizer";
import { WheelTile } from "./WheelTile";

const placeholder = [null, null, null, null, null, null];

type WheelsResultsProps = {
  hasVisualizer: boolean;
  parts?: WheelPartItem[];
  vehicleInfo?: VehicleInfo;
};

export const WheelList: FunctionComponent<WheelsResultsProps> = ({
  hasVisualizer,
  parts = placeholder,
  vehicleInfo,
}) => {
  const { t } = useTranslation();
  const [selectedProductId, setSelectedProducId] =
    useVisualizerProductId(parts);
  return (
    <section className="my-4 md:my-8">
      <div className="grid gap-2 md:gap-3 lg:gap-4 xl:gap-6 sm:grid-cols-2 xl:grid-cols-3">
        <Pagination className="sm:col-span-2 xl:col-span-3">
          {parts.map((product, key) => (
            <WheelTile
              selected={
                hasVisualizer &&
                selectedProductId === product?.partDetails.primaryPart.itemId
              }
              key={product?.partDetails?.primaryPart?.itemId || key}
              onSelect={hasVisualizer ? setSelectedProducId : null}
              part={product}
              vehicleId={vehicleInfo?.vehicleId}
            />
          ))}
        </Pagination>
      </div>
      {parts.length === 0 && (
        <NoData className="col-span-3">{t("searchResults.noData")}</NoData>
      )}
    </section>
  );
};
